import React from "react";
import { app_route_ids, app_route_keys } from "constants/urlPaths";
import EditIcon from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";

const pathName = app_route_ids[app_route_keys.MEMBERSHIPS];

export const MEMBERSHIPS_RA_PROPS = {
  basePath: pathName,
  history: {
    location: {
      pathname: pathName,
      search: "",
      hash: "",
    },
  },
  location: {
    pathname: pathName,
    search: "",
    hash: "",
  },
  match: {
    path: pathName,
    url: pathName,
    isExact: true,
    params: {},
  },

  resource: pathName,
  hasList: true,
  hasEdit: false,
  hasShow: false,
  hasCreate: false,
  syncWithLocation: false,
  perPage: 50,
};

export const SEE_REFERENCES_REDIRECT =
  "https://support.exlyapp.com/support/home";

export const DEFAULT_MEMBERSHIP_LIST_SIZE = 1;

export const DELETE_BUTTON_DIMENSIONS = {
  WIDTH: 20,
  HEIGHT: 20,
};

export const MEMBERSHIP_SECTION_KEY = "memberships";

// being used to find the format rgb(22,22,22) and therafter fetch 22,22,22
export const rgbRegex = /\(([^)]+)\)/;

export const MEMBERSHIP_SETTINGS_KEY = {
  HIDE_MEMBERSHIP: "hide_memberships_from_bookings_page",
  ENABLE_PRO_RATA: "enable_pro_rata_membership_upgrade",
};

export const MEMBERSHIP_TIER_DETAILS_KEYS = {
  TITLE: "title",
  DESCRIPTION: "description",
  PRICE: "price_per_head",
  PRICE_INTERNATIONAL: "price_international",
  IS_INTERNATIONAL_ENABLED: "is_international_enabled",
  ICON: "icon",
  IS_POPULAR: "is_popular",
  PERKS: "perks",
  COLOR: "color",
  CHANNELS: "channels",
  CUSTOM_LINKS: "custom_links",
  TIER_TYPE: "tier_type",
  TIER_PERK_POINTER: "tierPerkPointer",
};

export const CHANNEL_API_KEYS = {
  GROUP_ID: "group_uuid",
  GROUP_NAME: "group_name",
  GROUP_PRIORITY: "group_priority",
  GROUP_CREATED_AT: "group_created_at",
  CHANNEL_ID: "channel_uuid",
  CHANNEL_TYPE: "channel_type",
  CHANNEL_ACCESS_TYPE: "access_type",
  CHANNEL_NAME: "channel_name",
  CHANNEL_CREATED_AT: "channel_created_at",
  IS_MEMBERSHIP_MAPPED: "is_membership_mapped",
};

export const CUSTOM_LINK_API_KEYS = {
  LINK_UUID: "uuid",
};

export const MEMBERSHIP_MAPPED_LINKS_RESPONSE_KEY = "links";

export const COMMUNITY_CUSTOM_LINK_LIST_RESPONSE_KEY = "community_custom_links";

export const custom_link_display_strings = {
  view_links_button: "View links",
  link_list_modal_title: "Custom links",
  link_list_empty_message: "No custom links mapped to this membership.",
  custom_link_dropdown_label: "Add/Manage Links",
  custom_link_dropdown_placeholder: "Select links",
  custom_links_column_header: "Custom links",
};

export const membership_custom_link_error_messages = {
  mapping_failed_on_create:
    "Membership created, but failed to map custom links.",
  mapping_failed_on_update:
    "Membership updated, but failed to map custom links.",
};

export const membership_kyc_display_strings = {
  update_success: "Membership KYC verification updated successfully.",
  invalid_data: "Invalid Data",
};

export const membership_custom_link_log_errors = {
  mapping_failed_on_create:
    "Error while mapping custom links to membership on create",
  mapping_failed_on_update:
    "Error while mapping custom links to membership on update",
};

export const CMTModalColorScheme = {
  data: {
    primaryCard: "primary_card",
    detailCard: "details_card",
    textCard: "text_card",
    buttonCard: "button_card",
  },
  colors: {
    primary_card: "228, 239, 247",
    details_card: "255, 255, 255",
    text_card: "42, 94, 142",
    button_card: "0, 0, 0",
  },
  labels: {
    primary_card: "Primary card colour (top)",
    details_card: "Details card colour (bottom)",
    text_card: "Text colour",
    button_card: "Button colour",
  },
  title: "Theme Colors",
};

export const initialMembershipTierState = {
  title: "",
  description: "",
  price_per_head: null,
  price_international: null,
  is_international_enabled: false,
  icon: "",
  is_popular: false,
  perks: [],
  color: CMTModalColorScheme.colors,
  channels: [],
  custom_links: [],
};

export const PerkOptions = ({ handleEditClick, handleDeleteClick }) => {
  return [
    {
      title: "Edit",
      icon: <EditIcon />,
      handleClick: handleEditClick,
    },
    { title: "Delete", icon: <Delete />, handleClick: handleDeleteClick },
  ];
};
